import {Component} from '@angular/core';

@Component({
  selector: 'gn-app-root',
  template: `
    <router-outlet></router-outlet>
    <div id="gn-app-root"></div>
  `
})
export class GnAppRootComponent {

}
